import classes from "./CommonTable.module.css";

export function CommonTable({ data, cols }) {
  // console.log({ data, cols });
  function headerRow() {
    return cols.map((col, i) => (
      <div key={i} style={{ width: cols[i].w + "px" }}>
        <div
          className={`${classes.hdr_text} ${
            col.a &&
            (col.a === "left"
              ? classes.cell_text_left
              : classes.cell_text_right)
          }`}
        >
          {col.l}
        </div>
      </div>
    ));
  }

  function BodyRow({ iRow, row }) {
    // console.log(row, cols);
    return cols.map((col, iCol) => (
      <div key={iCol} style={{ width: col.w + "px" }}>
        <div
          className={` ${classes.cell_text} ${
            col.a &&
            (col.a === "left"
              ? classes.cell_text_left
              : classes.cell_text_right)
          }`}
        >
          {col.f ? col.f(iRow, iCol, row) : row[col.k]}
        </div>
      </div>
    ));
  }

  const emptyRow = (
    <div className={`${classes.table_row1} ${classes.table_row}`}>
      {cols.map((col, iCol) => (
        <div key={iCol} style={{ width: col.w + "px" }}>
          <div className={` ${classes.cell_text} `}></div>
        </div>
      ))}
    </div>
  );

  // console.log({data})
  return (
    <div className={classes.table}>
      <div className={classes.table_header}>
        <div className={classes.table_row}>{headerRow()}</div>
      </div>
      <div className={classes.table_body}>
        {data.length === 0
          ? emptyRow
          : data.map((row, iRow) => (
              <div
                key={iRow}
                className={`${
                  iRow % 2 === 0 ? classes.table_row1 : classes.table_row2
                } ${classes.table_row}`}
              >
                <BodyRow iRow={iRow} row={row} />
              </div>
            ))}
      </div>
    </div>
  );
}
